import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "moment/locale/fr";
import {
  addCandidateHobby,
  deleteCandidateHobby,
  updateCandidateHobby,
} from "../../../redux/actions/admin/CandidateActions";
import "moment/locale/fr";
import { CircularProgress } from "@material-ui/core";
import localStorageService from "../../../services/localStorageService";
import CustomAlert  from "../../shared/views/CustomAlert";

let HobbyResume = (props) => {
  const {
    hobbyList,
    addCandidateHobby,
    deleteCandidateHobby,
    updateCandidateHobby,
  } = props;

  const closeDeleteHobbyModal = React.useRef();
  const [
    displayingCandidateHobbyList,
    setDisplayCandidateHobbyList,
  ] = React.useState([]);
  const [showHobbyForm, setShowHobbyForm] = React.useState(false);
  const [showUpdateForm, setShowUpdateForm] = React.useState({});
  const [isHobbyAdding, setIsHobbyAdding] = React.useState(false);
  const [isHobbyUpdating, setIsHobbyUpdating] = React.useState(false);
  const [isHobbyDeletting, setIsHobbyDeletting] = React.useState(false);
  const [published, setPublished] = React.useState(false);
  const [hobbyTodelete, setHobbyTodelete] = React.useState(null);
  const [addHobbyFailed, setAddHobbyFailed] = React.useState(false);
  const [candidate, setCandidate] = React.useState(null);
  const [newHobby, setNewHobby] = React.useState({
    candidateId: "",
    id: "",
    title: "",
  });
  const [hobbyToUpdate, setHobbyToUpdate] = React.useState({});

  useEffect(() => {
    if (hobbyList !== null && displayingCandidateHobbyList.length === 0) {
      setDisplayCandidateHobbyList(hobbyList);
    }
  }, [hobbyList]);

  const toggleForm = () => {
    setShowHobbyForm(!showHobbyForm);
  };

  const toggleUpdateForm = (hobby) => {
    setHobbyToUpdate(hobby);
    setShowUpdateForm((prevState) => ({
      ...prevState,
      [hobby.id]: !prevState[hobby.id],
    }));
  };

  const handleCreateHobbySubmit = async () => {
    setIsHobbyAdding(true);
    let hobby = newHobby;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    hobby.candidateId = candidate.id;
    try {
      const data = await addCandidateHobby(hobby);
      if (data.success) {
        setAddHobbyFailed(false);
        setDisplayCandidateHobbyList(data.candidate.hobbies);
        setCandidate(data.candidate);
        clearHobbyForm();
        
      }
      setIsHobbyAdding(false);
      setPublished(true);
      setShowHobbyForm(false);
      
    } catch (error) {
      setAddHobbyFailed(true);
    }
  };
  const clearHobbyForm = () => {
    setNewHobby({
        candidateId: "",
        id:"",
        title: "",
    });
  };
  const handleUpdateHobbySubmit = () => {
    setIsHobbyUpdating(true);
    let hobby = hobbyToUpdate;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    hobby.candidateId = candidate.id;

    updateCandidateHobby(hobby).then((data) => {
      if (data.success) {
        setDisplayCandidateHobbyList(data.candidate.hobbies);
        setCandidate(data.candidate);
      }
      setIsHobbyUpdating(false);
      setPublished(false);
      toggleUpdateForm(hobby);
    });
  };

  const handleDeleteHobbySubmit = () => {
    setIsHobbyDeletting(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    deleteCandidateHobby(candidate?.id, hobbyTodelete?.id).then(
      (resp) => {
        if (resp.success === true) {
          setDisplayCandidateHobbyList(resp.candidate.hobbies);
          setCandidate(resp.candidate);
        }
        setHobbyTodelete("");
        closeDeleteHobbyModal.current.click();
        setIsHobbyDeletting(false);
      }
    );
  };

  return (
    <React.Fragment>
      <div className="bg-light-3 p-4">
        <div className="row">
          <div className="col-md-7 col-sm-5 d-flex align-items-center">
            <div className="section-title mb-0 ">
              <h3 className="title mb-0">
                {" "}
                <span>Loisirs</span>
              </h3>
            </div>
          </div>
          <div
            className="col-md-5 col-sm-7 mt-3 mt-sm-0 pr-3"
            style={{ textAlign: "right" }}
          >
            <button className="btn btn-primary" onClick={toggleForm}>
              Ajouter un loisir
            </button>
          </div>
        </div>
        <div className="row">
          {showHobbyForm == true && (
            <div className="col-xl-12">
              <div className="mt-4">
                <div className="bg-light-3">
                  <div _lpchecked="1">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <label>Titre</label>
                        <input
                          value={newHobby.title}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewHobby((prevState) => {
                              return { ...prevState, title: val };
                            });
                          }}
                        />
                      </div>
                      <div className="col-12 mt-4">
                        <button
                          className="btn btn-primary"
                          onClick={handleCreateHobbySubmit}
                          disabled={isHobbyAdding}
                          style={{ textAlign: "right", float: "right" }}
                        >
                          Ajouter &nbsp;{" "}
                          {isHobbyAdding ? (
                            <CircularProgress size={15} />
                          ) : (
                            <span></span>
                          )}
                        </button>
                        &nbsp;{" "}
                        &nbsp;{" "}
                        {addHobbyFailed && (
                            <div  className="col-12 mt-5">
                               <CustomAlert content="Erreur lors de cette opération, veuillez réessayer" type="alert-danger" />
                            </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          )}
        </div>
        <div className="row">
          <div className="col-xl-12 mt-4">
            {displayingCandidateHobbyList?.length !== 0 && (
              <div className="timeline-box bg-white p-3 ">
                {displayingCandidateHobbyList?.map((hobby, index) => (
                  <div className="jobster-timeline-item" key={index}>
                    <div className="jobster-timeline-info">
                      <div className="dashboard-timeline-info">
                        <div className="row">
                          <div className="col-12">
                            <div className="row">
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-10">
                                      {hobby.title}
                                  </div>
                                  <div className="col-2">
                                    <div className="dashboard-timeline-edit">
                                      <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                        <li className="pr-2">
                                          <a
                                            href="javascript:void(0)"
                                            onClick={() =>
                                              toggleUpdateForm(hobby)
                                            }
                                          >
                                            <i className="fas fa-pencil-alt"></i>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            className="text-danger"
                                            data-toggle="modal"
                                            title=""
                                            data-target="#deleteHobby"
                                            data-original-title="Delete"
                                          >
                                            <i
                                              className="far fa-trash-alt text-danger"
                                              onClick={() =>
                                                setHobbyTodelete(hobby)
                                              }
                                            ></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            {showUpdateForm[hobby.id] && (
                              <div className="col-12">
                              <div className="mt-4">
                                <div className="bg-light-3 p-4">
                                  <div _lpchecked="1">
                                    <div className="form-row">
                                      <div className="form-group col-md-12">
                                        <label>Titre </label>
                                        <input
                                          value={
                                            hobbyToUpdate.title
                                          }
                                          type="text"
                                          className="form-control"
                                          id="title"
                                          onChange={(e) => {
                                            let val = e.target?.value;
                                            setHobbyToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  title: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="col-12 mt-4">
                                        <button
                                          className="btn btn-primary"
                                          onClick={
                                            handleUpdateHobbySubmit
                                          }
                                          disabled={
                                            isHobbyUpdating
                                          }
                                          style={{
                                            textAlign: "right",
                                            float: "right",
                                          }}
                                        >
                                          Mettre à jour &nbsp;{" "}
                                          {isHobbyUpdating ? (
                                            <CircularProgress
                                              size={15}
                                            />
                                          ) : (
                                            <span></span>
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Start Delete  modale */}
        <div
          className="modal fade"
          id="deleteHobby"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header p-4">
                <h4 className="mb-0 text-center">Suppression d'un loisir</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form className="mt-2">
                <div className="modal-body">
                  <div>
                    <div className="form-row">
                      <p>
                        Voulez vous supprimer ce loisir:{" "}
                        {hobbyTodelete?.title}?
                      </p>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className="btn btn-primary"
                    ref={closeDeleteHobbyModal}
                  >
                    NON
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleDeleteHobbySubmit}
                    disabled={isHobbyDeletting}
                  >
                    OUI &nbsp;{" "}
                    {isHobbyDeletting ? (
                      <CircularProgress size={15} />
                    ) : (
                      <span></span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* End Delete  modale */}
      </div>
    </React.Fragment>
  );
};

HobbyResume.propTypes = {
  addCandidateHobby: PropTypes.func.isRequired,
  deleteCandidateHobby: PropTypes.func.isRequired,
  updateCandidateHobby: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  addCandidateHobby: PropTypes.func.isRequired,
  deleteCandidateHobby: PropTypes.func.isRequired,
  updateCandidateHobby: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, {
  addCandidateHobby,
  deleteCandidateHobby,
  updateCandidateHobby,
})(HobbyResume);
